var DataTable = require('datatables.net');
$ = jQuery = DataTable.$;
jQuery(document).ready(function($) {

	if ($('#events-table').length != 0) {


		var eventsTable = $('#events-table').DataTable({
			processing: true,
			//serverSide: true,
			//stateSave: true,
			ajax: {
				url: '/counting/event/list/', //  route('counting.event.list').toString(),
				type: 'POST',
				// data: function (d) { }
			},
			columns: [
				{data: 'id', name: 'id', visible: false, searchable: false},
				{data: 'name', name: 'libelle', className: 'text-left'},
				{data: 'dateBegin', name: 'dateBegin', className: 'text-center'},
				{data: 'dateEnd', name: 'dateEnd', className: 'text-center'},
				{data: 'action', name: 'action'}
			],
			// order: [[3, 'desc'], [0, 'desc']],
			/**
			 *
			 preDrawCallback: function (settings) {
			 var api = this.api();
			 
			 var order = api.order();
			 
			 if (order[0][1] == 'asc') {
			 order[1] = [0, 'asc'];
			 } else {
			 order[1] = [0, 'desc'];
			 }
			 
			 api.order(order);
			 },
			 drawCallback: function (settings) {
			 
			 $('#files-table-title').remove();
			 $('<p id="files-table-title"><b>' + Lang._n('Dernier fichier ajouté', 'Derniers fichiers ajoutés', settings._iRecordsDisplay) + '</b></p>').prependTo('#files-table_wrapper');
			 }
			 */
		});

	}


	if ($('#event-dashboard').length) {

		var Highcharts = require('highcharts');

		// Load module after Highcharts is loaded
		//require('highcharts/modules/exporting')(Highcharts);
		require('highcharts/highcharts-more')(Highcharts);
		require('highcharts/modules/solid-gauge')(Highcharts);
		//require('highcharts/highcharts-3d')(Highcharts);
 
		var eventId = $('#event-dashboard').data('id');
		var type = $('#event-dashboard').data('type');

		var eventName = '';
		var eventInstallationName = '';

		var chiffreAffluenceMinIn = [];
		var chiffreAffluenceMinOut = [];
		var legendeAffluenceMinOut = [];
		var chiffreInside = [];
		var inside = 0;

		var max_gauge = $('#event-dashboard').data('gauge'); // 2000;
		var replayStep = 0;

		initEvent();

		if ($('#event-dashboard').data('replay') === 1) {
			// replay
			console.log('replay');
			setInterval(function () {

				console.log(replayStep, chiffreAffluenceMinOut.length);
				if (replayStep <= chiffreAffluenceMinOut.length) {
					drawGarphsReplay(replayStep);
					replayStep++;
				} else {
					// redirige vers dashboard
					//document.location.href = '../dashboard/';
				}

			}, 500); //

		} else {
			// dashboard
			console.log('dashboard');
			setInterval(function () {
				drawGauge( );
			}, 1000); // tt 1sec   pour le inside en live
		  
			setInterval(function () {
				drawGarphs();
			}, 60000); // tt minutes
		}


		/**
		 *
		 * @returns {undefined}
		 */
		function drawGarphsReplay(step) {
			console.log('drawGarphsReplay', step);
 
			initGauge(step);
			initTimeline(step);

			return true;
		}

		/**
		 *
		 * @returns {undefined}
		 */
		function getDatasDashbord( ) {

			$.ajax({
				url: '/counting/' + type +'/dashboard/datas', //  route('counting.event.dashboard.datas').toString(),
				type: 'GET',
				dataType: 'json',
				async: false, // Mode synchrone
				data: {
					event_id: eventId,
				},
				success: function (response) {

					// Event
					eventName = response.name;

					// Instalation
					eventInstallationName = response.name;


					//console.log( item.kpis[0].affluenceMinIn );
					legendeAffluenceMinOut = response.kpis[0].calculLegende;

					// $('#inside-name').html(item.kpis[0].inside[0]);
					inside = response.kpis[0].calculInsideNow;

					chiffreInside = response.kpis[0].inside;
					chiffreAffluenceMinIn = response.kpis[0].calculAffluenceMinIn;

					chiffreAffluenceMinOut = response.kpis[0].calculAffluenceMinOut;
 
					return true;
				}
			});

		}

		/**
		 *
		 * @returns {undefined}
		 */
		function initEvent() {

			var res = getDatasDashbord( );


			$('#event-name').html(eventName);
			$('#installation-name').html(eventInstallationName);

			initGauge();

			initTimeline();

			return res;

		}


		/**
		 *
		 * @returns {undefined}
		 */
		function drawGauge( ) {
			console.log('drawGauge'); 
			var res = getDatasDashbord( ); 
			initGauge(); 
			return res;
		}
		
		/**
		 *
		 * @returns {undefined}
		 */
		function drawGarphs( ) {
			console.log('drawGarphs');

			var res = getDatasDashbord( );


			initGauge();
			initTimeline();

			return res;
		}

		/**
		* 
		* @returns {undefined}
		*/
		function afficheDate() {
			var now = new Date();
			var annee = now.getFullYear();
			var mois = now.getMonth() + 1;

			 if(mois<10) {
				mois = "0"+mois;
			 }

			var jour = now.getDate();
			var heure = now.getHours();

			 if(heure<10) {
				heure = "0"+heure;
			}

			var minute = now.getMinutes();
			if(minute<10) {
				minute = "0"+minute;
			}

			var seconde = now.getSeconds();
			if(seconde<10) {
				seconde = "0"+seconde;
			}
			
			return jour + "/" + mois + "/" + annee + " " + heure + ":" + minute; // + " minutes " + seconde + " secondes";
			// $('#refresh-name').html("Refresh le " + jour + "/" + mois + "/" + annee + " à " + heure + " heure " + minute + " minutes " + seconde + " secondes"); 
		}

		/**
		 *
		 * @returns {undefined}
		 */
		function initGauge(step) {

			if (typeof (step) != 'undefined') {

// todo pas forcement un regroupement par 5, recup la valeur ?
				inside = chiffreInside[ (step * 5) ];

				// console.log(inside);
			}
			
			var dateGauge = afficheDate() ;
// Jauge
			var gaugeOptions = {

				chart: {
					type: 'solidgauge'
				},

				title: null,
	/*
pane: {
        center: ['50%', '85%'],
        
        background: {
            backgroundColor:
                Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
            innerRadius: '60%',
            outerRadius: '100%',
            shape: 'circle'
        }
    },*/

/************/
				pane: {
					center: ['50%', '85%'],
					size: '120%',
					startAngle: -90,
					endAngle: 90,
					background: {
						backgroundColor:
							Highcharts.defaultOptions.legend.backgroundColor || '#EEE',
						innerRadius: '60%',
						outerRadius: '100%',
						shape: 'arc'
					}
				},

				tooltip: {
					enabled: false
				},

// the value axis
				yAxis: {
					stops: [
						[0.1, '#55BF3B'], // green
						[0.5, '#DDDF0D'], // yellow
						[0.9, '#DF5353'] // red
					],
					lineWidth: 0,
					minorTickInterval: null,
					tickAmount: 2,
					title: {
						y: -70
					},
					labels: {
						y: 16
					}
				},
 
				plotOptions: {
					solidgauge: {
						animation: false,
						dataLabels: {
							y: 5,
							borderWidth: 0,
							useHTML: true
						}
					}
				}
			};

// The speed gauge
			var chartSpeed = Highcharts.chart('container-speed', Highcharts.merge(gaugeOptions, {
				yAxis: {
					min: 0,
					max: max_gauge,
					title: {
						y: -150,
						text: '<div style="text-align:center">' +
								'<span style="font-size:50px">'+dateGauge+'</span><br/>' + 
								'</div>'
					}
				},

				credits: {
					enabled: false
				},

				series: [{
						name: 'Inside',
						data: [inside],
						dataLabels: {
							format:
								'<div style="text-align:center">' +
								'<span style="font-size:50px">{y}</span><br/>' +
								'<span style="font-size:12px;opacity:0.4">Présents</span>' +
								'</div>'
						},
						tooltip: false /* {
						 valueSuffix: ' km/h'
						 }*/
					}]

			}));


			return true;

		}

		/**
		 *
		 * @returns {undefined}
		 */
		function initTimeline(step) {

			thisChiffreAffluenceMinIn = chiffreAffluenceMinIn;
			thisChiffreAffluenceMinOut = chiffreAffluenceMinOut;
			thisLegendeAffluence = legendeAffluenceMinOut;

			if (typeof (step) != 'undefined') {

				timerAffichage = step;// (2 * 60); //240;
				thisChiffreAffluenceMinIn = chiffreAffluenceMinIn.slice(0, timerAffichage);
				thisChiffreAffluenceMinOut = chiffreAffluenceMinOut.slice(0, timerAffichage);
				//thisLegendeAffluence = legendeAffluenceMinOut.slice(0, timerAffichage);
			}

			// affiche le graph
			Highcharts.chart('container', {

				chart: {
					type: 'column',
					animation: false,
      /*  options3d: {
            enabled: true,
            alpha: 15,
            beta: 15,
            viewDistance: 25,
            depth: 40
        }*/
				},

				title: false, /*{
				 text: 'Total fruit consumtion, grouped by gender'
				 },*/
				colors: ['green', 'red', ],
				xAxis: {
					 categories: thisLegendeAffluence,
					visible: false,
					 
				},

				yAxis: {
					allowDecimals: false,
				 endOnTick: false, 
				 startOnTick: false, 
					maxPadding: 0.01,
					// min: 0, 
					title: {
						text: 'Passages'
					}
				},

				tooltip: {
            /*depth: 40,*/
					formatter: function () {
						return '<b>' + this.x + '</b><br/>' +
							this.series.name + ': ' + this.y + '<br/>' +
							'Total: ' + this.point.stackTotal;
					}
				},

				drilldown: {
					animation: {
						duration: 0
					}
				},
				plotOptions: {
					series: {
						animation: {
							duration: 0
						}
					},
					column: {
						stacking: 'normal'
					}
				},

				credits: {
					enabled: false
				},
				series: [{
						name: 'Entrées dans la zone',
						data: thisChiffreAffluenceMinIn,
						stack: 'In'
					}, {
						name: 'Sorties de la zone',
						data: thisChiffreAffluenceMinOut,
						stack: 'Out'
					}]
			});





			//	afficheDate();


			return true;
		}



	}

});